import cloneDeep from 'lodash/cloneDeep';
import { emptyObj, getRequestData } from '@/utils';
import { setGoodsBsnl, qryBearingSubs, qrySubsPlanDetailBsnl, deviceReceiptNbrCheckBsnl } from '@/pages/ModifyGoods/services/modifyGoods';

export default {
  namespace: 'modifyGoods',
  state: {
    step: 0, // 修改实物信息业务流程的步骤
    searchCustInfo: {}, // 从搜索页面同步过来的用户信息
    serviceType: {}, // 从搜索页面同步过来的服务类型
    subServiceType: {}, // 从搜索页面同步过来的子服务类型
    activeTabsKey: '', // 当前tabs
    proprietaryGoods: {}, // 专有实物在主订户上
    shareGoods: {}, // 共享实物在承载订户上
    bearingSubsDetail: {}, // 承载订户详情
    bearingSubsPlanDetail: {}, // 承载订户套餐详情
  },
  effects: {
    *setGoodsBsnl({ payload }, { call }) {
      const response = yield call(setGoodsBsnl, payload);
      return getRequestData(response);
    },
    *qryBearingSubs({ payload }, { call, put }) {
      const response = yield call(qryBearingSubs, payload);
      const { subsDto } = getRequestData(response);
      yield put({
        type: 'save',
        payload: { bearingSubsDetail: subsDto },
      });
    },
    *qrySubsPlanDetailBsnl({ payload }, { call, put }) {
      const response = yield call(qrySubsPlanDetailBsnl, payload);
      const { subsPlanDetailDto } = getRequestData(response);
      yield put({
        type: 'save',
        payload: { bearingSubsPlanDetail: subsPlanDetailDto },
      });
    },
    *deviceReceiptNbrCheckBsnl({ payload }, { call }) {
      const response = yield call(deviceReceiptNbrCheckBsnl, payload);
      return getRequestData(response);
    },
  },

  reducers: {
    tabsSave(state, { payload, activeTabsKey }) {
      const tabState = { ...state[activeTabsKey], ...payload };
      state[activeTabsKey] = cloneDeep(tabState);
      return {
        ...state,
      };
    },
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear(state) {
      return emptyObj(state);
    },
  },
};
